export default __webpack_public_path__ + "static/media/Polearm of the Black Pharaoh.f46347cb.jpg";